import { gradient } from "./baseColors";
import { ThemeGradientColorsNames, ThemeGradients } from "./palette.types";

const gradientHandler: ProxyHandler<ThemeGradients> = {
    get(target, prop) {
        if (prop === "getGradients") {
            return (...params: [ThemeGradientColorsNames]) => {
                return target[params[0]];
            };
        } else {
            return () => {
                const colors = target[prop as ThemeGradientColorsNames];
                return `linear-gradient(90deg,${colors[0]} 0%,${colors[1]} 100%);`;
            };
        }
    },
};

export const gradientProxy = new Proxy(gradient as unknown as ThemeGradients, gradientHandler);
